

import React, { useState } from 'react';
import './Sources.css';
import { Link } from 'react-router-dom';
import logo from './images/CompanyLogo.svg';
import REC1 from './images/REC1.svg';
import REC2 from './images/REC2.svg';
import REC3 from './images/REC3.svg';
import REC4 from './images/REC4.svg';
import REC5 from './images/REC5.svg';
import REC77 from './images/REC77.svg';

const Sources = () => {
  const [activeSection, setActiveSection] = useState('foundations');

  const renderContent = () => {
    switch (activeSection) {
      case 'foundations':
        return (
          <div className="conttent">
            {/* <div classname="rec77" >
              <img  src={REC77} className="logoo" alt="Logo">
              </img>
            </div> */}
             <div className="logo">
                <Link to="/">
                    <img src={logo} className="logoo" alt="Logo" />
                </Link> </div>
            <div className="section-item">
              <h2 className="section-title">DevOps Fundamentals</h2>
              <img src={REC1}></img>
              <p className="section-description">
                This section dives into the philosophy and practices <br></br> that bridge the gap between development and operations teams.<br></br> 
                It covers collaboration, automation, and continuous<br></br>  delivery to streamline software development and deployment.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Version Control (Git)</h2>
              <img src={REC2}></img>
              <p className="section-description">
                Git is the most popular version control system, <br></br> allowing you to track changes in code, revert back <br></br> to previous versions if needed, and collaborate effectively<br></br>  with other developers. 
                This section teaches you how to use Git for <br></br> versioning, branching, merging, and conflict resolution.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Infrastructure as Code (IaC)</h2>
              <img src={REC3}></img>
              <p className="section-description">
                Instead of manually configuring servers and networks,<br></br>  IaC lets you define your infrastructure usignupg code (like Terraform). <br></br> 
                This provides consistency, repeatability, and easier <br></br> collaboration by treating infrastructure like any other codebase.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Security in DevOps</h2>
              <img src={REC4}></img>
              <p className="section-description">
                This section introduces security best practices throughout the DevOps life-cycle,<br></br>  including vulnerability scanning, secrets management, and secure coding techniques.<br></br> 
            Security is a crucial aspect of DevOps, integrating security practices and principles throughout the DevOps.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Continuous Integration & Delivery (CI/CD)</h2>
              <img src={REC5}></img>
              <p className="section-description">
                CI/CD automates the software development life cycle. It involves frequently merging code changes,<br></br>  running automated tests, and deploying updates to production environments. 
                This section covers the CI/CD pipeline, <br></br> its benefits, and popular tools like Jenkins or Git Lab CI/CD.<br></br> 
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Containerization & Orchestration</h2>
              <img src={REC1}></img>
              <p className="section-description">
                This section explores containerization usignupg Docker and <br></br> container orchestration with Kubernetes.<br></br>  Docker allows you to package applications<br></br>  with all their dependencies into lightweight, portable containers.<br></br>  
                Kubernetes helps you manage containerized applications at<br></br>  scale by automating deployment, scaling, and networking. <br></br> 
                This section will equip you with the knowledge to build and <br></br> deploy containerized applications and manage them efficiently.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
          </div>
        );
      case 'advanced':
        return (
          <div className="conttent">
                  <div className="logo">
                <Link to="/">
                    <img src={logo} className="logoo" alt="Logo" />
                </Link> </div>
            <div className="section-item">
              <h2 className="section-title">Continuous Integration & Delivery (CI/CD)</h2>
              <img src={REC1}></img>
              <p className="section-description">
                CI/CD automates the software development life cycle. It involves frequently merging code changes, running automated tests, and deploying updates to production environments. 
                This section covers the CI/CD pipeline, its benefits, and popular tools like Jenkins or Git Lab CI/CD.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Configuration Management</h2>
              <img src={REC2}></img>
              <p className="section-description">
                This section goes beyond IaC by focusignupg on tools like Ansible, Chef, or Puppet. 
                These tools automate the configuration of servers and infrastructure, ensuring consistency across your environment. 
                You'll learn how to write configuration scripts, manage configurations across multiple servers, and apply changes in a controlled manner.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Version Control (Git)</h2>
              <img src={REC3}></img>
              <p className="section-description">
                Git is the most popular version control system, <br></br> allowing you to track changes in code, revert back <br></br> to previous versions if needed, and collaborate effectively<br></br>  with other developers. 
                This section teaches you how to use Git for <br></br> versioning, branching, merging, and conflict resolution.
              </p>
              <button className="buttondemo-button">Demo  </button> 
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Infrastructure as Code (IaC)</h2>
              <img src={REC4}></img>
              <p className="section-description">
                Instead of manually configuring servers and networks,<br></br>  IaC lets you define your infrastructure usignupg code (like Terraform). <br></br> 
                This provides consistency, repeatability, and easier <br></br> collaboration by treating infrastructure like any other codebase.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
            <img src={REC5}></img>
              <h2 className="section-title">Security in DevOps</h2>
              <p className="section-description">
                This section introduces security best practices throughout the DevOps life-cycle,<br></br>  including vulnerability scanning, secrets management, and secure coding techniques.<br></br> 
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Continuous Integration & Delivery (CI/CD)</h2>
              <img src={REC1}></img>
              <p className="section-description">
                CI/CD automates the software development life cycle. It involves frequently merging code changes,<br></br>  running automated tests, and deploying updates to production environments. 
                This section covers the CI/CD pipeline, <br></br> its benefits, and popular tools like Jenkins or Git Lab CI/CD.<br></br> 
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Containerization & Orchestration</h2>
              <img src={REC2}></img>
              <p className="section-description">
                This section explores containerization usignupg Docker and <br></br> container orchestration with Kubernetes.<br></br>  Docker allows you to package applications<br></br>  with all their dependencies into lightweight, portable containers.<br></br>  
                Kubernetes helps you manage containerized applications at<br></br>  scale by automating deployment, scaling, and networking. <br></br> 
                This section will equip you with the knowledge to build and <br></br> deploy containerized applications and manage them efficiently.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
          </div>
        );
      case 'real-world':
        return (
          <div className="conttent">
                  <div className="logo">
                <Link to="/">
                    <img src={logo} className="logoo" alt="Logo" />
                </Link> </div>
            <div className="section-item">
              <h2 className="section-title">Containerization & Orchestration</h2>
              <img src={REC3}></img>
              <p className="section-description">
                This section explores containerization usignupg Docker and container orchestration with Kubernetes. Docker allows you to package applications with all their dependencies into lightweight, portable containers. 
                Kubernetes helps you manage containerized applications at scale by automating deployment, scaling, and networking. 
                This section will equip you with the knowledge to build and deploy containerized applications and manage them efficiently.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Version Control (Git)</h2>
              <img src={REC4}></img>
              <p className="section-description">
                Git is the most popular version control system, <br></br> allowing you to track changes in code, revert back <br></br> to previous versions if needed, and collaborate effectively<br></br>  with other developers. 
                This section teaches you how to use Git for <br></br> versioning, branching, merging, and conflict resolution.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Infrastructure as Code (IaC)</h2>
              <img src={REC5}></img>
              <p className="section-description">
                Instead of manually configuring servers and networks,<br></br>  IaC lets you define your infrastructure usignupg code (like Terraform). <br></br> 
                This provides consistency, repeatability, and easier <br></br> collaboration by treating infrastructure like any other codebase.
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Security in DevOps</h2>
              <img src={REC1}></img>
              <p className="section-description">
                This section introduces security best practices throughout the DevOps life-cycle,<br></br>  including vulnerability scanning, secrets management, and secure coding techniques.<br></br> 
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Continuous Integration & Delivery (CI/CD)</h2>
              <img src={REC2}></img>
              <p className="section-description">
                CI/CD automates the software development life cycle. It involves frequently merging code changes,<br></br>  running automated tests, and deploying updates to production environments. 
                This section covers the CI/CD pipeline, <br></br> its benefits, and popular tools like Jenkins or Git Lab CI/CD.<br></br> 
              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
            <div className="section-item">
              <h2 className="section-title">Containerization & Orchestration</h2>
              <img src={REC3}></img>
              <p className="section-description">
                This section explores containerization usignupg Docker and <br></br> container orchestration with Kubernetes.<br></br>  Docker allows you to package applications<br></br>  with all their dependencies into lightweight, portable containers.<br></br>  
                Kubernetes helps you manage containerized applications at<br></br>  scale by automating deployment, scaling, and networking. <br></br> 

              </p>
              <button className="buttondemo-button">Demo</button>
              <button className="buttongithub-button">GitHub</button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="app-container">
      <div className="navbuttons">
        <button className="button navbutton" onClick={() => setActiveSection('foundations')}>Foundations</button>
        <button className="button navbutton" onClick={() => setActiveSection('advanced')}>Advanced</button>
        <button className="button navbutton" onClick={() => setActiveSection('real-world')}>Real-World</button>
      </div>
      <div className="content-container">
        {renderContent()}
      </div>
    </div>
  );
};

export default Sources;
